import React, { Component } from "react";

import { withStyles } from '@mui/styles';
import styles from './index.styles';
import { withTranslation } from 'react-i18next';
import { Table, TableBody, TableCell, TableHead, TableRow, Tooltip, TableSortLabel, List, ListItem, ListItemIcon, ListItemText, IconButton } from "@mui/material";
import { Box } from "@mui/system";
import fpro from './images/fpro.png';
import InfiniteScroll from 'react-infinite-scroll-component';
import PropTypes from "prop-types";
import FilterAltOffOutlinedIcon from '@mui/icons-material/FilterAltOffOutlined';
import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded';

const legend = [
    { color: "linear-gradient(155deg, rgb(212,209,0) 0%, rgb(255,255,189) 90%)", label: "Assigned" },
    { color: "linear-gradient(155deg, rgb(253, 253, 252) 0%, rgb(4, 144, 243) 90%)", label: "Hold" },
    { color: "linear-gradient(155deg, rgb(23,166,0) 0%, rgb(196,255,189) 90%)", label: "Stocked" },
    { color: "linear-gradient(155deg, rgb(253, 253, 252) 0%, rgb(249, 27, 27) 90%)", label: "Deactivate" },
];

let FilterObj = {
    sortOrder: 'desc',
    sortColumn: 'created_on',
    tableName: ''
}

function desc(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function stableSort(array, cmp) {
    if (array && array.length <= 0) {
        return [];
    }
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = cmp(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
    return order === "desc"
        ? (a, b) => desc(a, b, orderBy)
        : (a, b) => -desc(a, b, orderBy);
}

class EnhancedTableHead extends React.Component {
    createSortHandler = (property, field) => event => {
        this.props.onRequestSort(event, property, field);
    };

    render() {
        const {
            order,
            orderBy,
            sortId,
            t
        } = this.props;
        const rows = [
            { id: "name", numeric: false, disablePadding: false, label: t('Task.Patient'), padding: '8px', field: 'name' },
            { id: "stock_code", numeric: false, disablePadding: false, label: t('Unplugged.SearchPopup.StockCode'), padding: '8px', field: 'stock_code' },
            { id: "bin_position", numeric: false, disablePadding: false, label: t('Fastlan.Component.BinPosition'), padding: '8px', field: 'bin_position' },
        ];

        return (
            <TableHead>
                <TableRow>
                    <TableCell style={{ padding: '0px', border: 'none' }}></TableCell>
                    {rows.map(row => {
                        return (
                            <TableCell
                                key={row.id}
                                numeric={row.numeric}
                                padding={row.disablePadding ? "none" : "default"}
                                sortDirection={orderBy === row.id ? order : false}
                                style={{ padding: row.padding, color: 'grey' }}
                            >
                                <Tooltip
                                    title={t("Global.Label.Filter.Sort")}
                                    placement={"right"}
                                    enterDelay={300}
                                >
                                    <TableSortLabel
                                        active={orderBy === row.field && sortId === row.id}
                                        direction={order}
                                        onClick={this.createSortHandler(row.id, row.field)}
                                    >
                                        {row.label}
                                    </TableSortLabel>
                                </Tooltip>
                            </TableCell>
                        );
                    }, this)}
                </TableRow>
            </TableHead>
        );
    }
}

EnhancedTableHead.propTypes = {
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.string.isRequired,
    orderBy: PropTypes.string.isRequired,
    sortId: PropTypes.string.isRequired
};
EnhancedTableHead = withTranslation()(EnhancedTableHead);

export class FastlaneProLayout extends Component {
    constructor(props) {
        super(props);
        this.state = {
            binsCount: 1,
            rowsPerPagePending: 10,
            hasMore: true,
            BoxID: this.props.BoxID,
            order: "desc",
            orderBy: "created_on",
            isFiltered: false,
            status: 'All',
            fastlaneBinsMatrix: { _recentOrders: [] },
            availableBins: 0,
            yourPosition: 0,
        }
    }

    componentDidMount() {
        this.fetchFastlaneBinMatrix('All');
    }

    componentDidUpdate(prevProps) {
        if (this.props.BoxID !== prevProps.BoxID) {
            this.setState({ BoxID: this.props.BoxID });
            this.fetchFastlaneBinMatrix('All');
        }
        if (this.props.makeAPICall !== prevProps.makeAPICall && this.props.makeAPICall) {
            this.setState({ BoxID: this.props.BoxID });
            this.reloadGrid();
        }
    }

    handleStockCodeClick = (event, item) => {
        event && event.preventDefault();
        this.props.getPrescriptionDetails(item.bin_id, item.order_id);
    }

    fetchMoreData = (type) => {
        const { fastlaneBinsMatrix } = this.state;
        const _recentOrders = fastlaneBinsMatrix._recentOrders.length && fastlaneBinsMatrix._recentOrders;
        if (type === 'pending') {
            let total = 0;
            total = _recentOrders.length;
            if (total > 0) {
                this.setState({ total: this.state.total + total, rowsPerPagePending: this.state.rowsPerPagePending + 10 });
            } else {
                this.setState({ hasMore: false });
            }
        }
    }

    handleRequestSort = (event, property, field) => {
        const { status } = this.state;
        const orderBy = property;
        let order = "desc";
        if (this.state.orderBy === orderBy) {
            order = this.state.order === "asc" ? "desc" : "asc";
        } else if (this.state.order === order) {
            order = "asc";
        } else {
            order = "desc";
        }
        this.setState({ order, orderBy, sortId: property });
        FilterObj.sortOrder = order;
        FilterObj.sortColumn = field;
        FilterObj.tableName = property === 'name' ? 'customers' : property === 'bin_position' ? 'fastlane_matrix' : '';
        this.fetchFastlaneBinMatrix(status)
    };

    handleStatusClick = (e, label) => {
        e && e.preventDefault();
        this.setState({ isFiltered: true, status: label });
        this.fetchFastlaneBinMatrix(label)
    }

    fetchFastlaneBinMatrix = (status) => {
        const boxId = this.props && this.props.selectedBox && this.props.selectedBox.id
        if (![undefined, 'undefined', null, 'null', ''].includes(boxId)) {
            fetch(process.env.REACT_APP_BASEURL + `fastlane/matrix?boxId=${boxId}&status=${status}&tableName=${FilterObj.tableName}&sortColumn=${FilterObj.sortColumn}&sortOrder=${FilterObj.sortOrder}`, {
                method: 'get',
                withCredentials: true,
                headers: {
                    Authorization:
                        'Bearer ' +
                        JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
                            .jwtToken,
                    'Content-Type': 'application/json',
                },
            }).then((response) => {
                try {
                    return response.json();
                } catch (error) {
                    return null;
                }
            }).then((fastlaneBinsMatrixResponse) => {
                const data = fastlaneBinsMatrixResponse && fastlaneBinsMatrixResponse.data;
                this.setState({ fastlaneBinsMatrix: data });
                if (this.state.isFiltered === false) {
                    this.setState({ availableBins: data.AvailableBins, yourPosition: data.YourPosition });
                }
            })
        }
    }

    clearFilters = () => {
        FilterObj.sortOrder = 'desc';
        FilterObj.sortColumn = 'created_on';
        FilterObj.tableName = '';
        this.fetchFastlaneBinMatrix('All');
        this.setState({ isFiltered: false, status: 'All' });
    }

    reloadGrid = () => {
        FilterObj.sortOrder = 'desc';
        FilterObj.sortColumn = 'created_on';
        FilterObj.tableName = '';
        this.setState({ isFiltered: false })
        this.fetchFastlaneBinMatrix('All');
    }

    render() {
        const { t } = this.props;
        const { fastlaneBinsMatrix, isFiltered, availableBins, yourPosition } = this.state;
        const _recentOrders = fastlaneBinsMatrix && fastlaneBinsMatrix._recentOrders;
        const isFilterDisabled = (_recentOrders && _recentOrders.length) ? isFiltered ? false : true : true;
        localStorage.setItem('fBinIds', fastlaneBinsMatrix && fastlaneBinsMatrix.YourPosition && fastlaneBinsMatrix.YourPosition);
        return (
            <Box
                component='div'
                sx={{
                    width: '100%',
                    textAlign: 'center',
                    mt: '2%',
                }}
            >
                <img
                    src={fpro}
                    style={{
                        width: '15%',
                        color: '#0a5d66'
                    }}
                    alt='no-icon'
                />

                <div style={{ width: '100%', display: 'flex', padding: '20px', lineHeight: 3 }}>
                    <div style={{ width: '25%' }}>
                        <div style={{ textAlign: 'left' }}>
                            <label style={{ color: '#000', fontSize: '1.2rem', fontWeight: 450 }}>
                                {t('Fastlan.Component.Title')}
                            </label>
                        </div>
                        <div style={{ textAlign: 'left' }}>
                            <label style={{ color: '#858585' }}>
                                {t('API.DeviceType.Available')}:&nbsp;{availableBins}
                            </label>
                        </div>
                        <div style={{ textAlign: 'left' }}>
                            <label style={{ color: '#858585' }}>
                                {t('Fastlan.Component.YourPosition')}:&nbsp;{yourPosition}
                            </label>
                        </div>
                    </div>
                    <div style={{ width: '75%' }}>
                        <div style={{ textAlign: 'center', display: 'flex', justifyContent: "space-between", alignItems: "center" }}>
                            <label style={{ color: '#000', fontSize: '1.2rem', fontWeight: 450, flex: '1' }}>
                                {t('Fastlan.Component.RecentOrdersTitle')}
                            </label>
                            <Tooltip key="reload-grid" title={t("Reload")}>
                                <IconButton onClick={() => this.reloadGrid()} sx={{ backgroundColor: "transparent" }}>
                                    <RefreshRoundedIcon />
                                </IconButton>
                            </Tooltip>
                            <Tooltip key="clear-filters" title={t("Report.Assign.ClearFiltersTooltip")}>
                                <IconButton disabled={isFilterDisabled} onClick={() => this.clearFilters()} sx={{ backgroundColor: "transparent" }}>
                                    <FilterAltOffOutlinedIcon />
                                </IconButton>
                            </Tooltip>
                        </div>
                        <div style={{ textAlign: 'left' }}>
                            <InfiniteScroll
                                dataLength={this.state.rowsPerPagePending}
                                next={() => this.fetchMoreData('pending')}
                                hasMore={this.state.hasMore}
                                height={410}
                                endMessage={
                                    <p style={{ textAlign: 'center' }}>
                                        <b>{t("Console.YouHaveSeenIt")}</b>
                                    </p>
                                }>
                                <Table>
                                    <EnhancedTableHead
                                        order={FilterObj.sortOrder}
                                        orderBy={FilterObj.sortColumn}
                                        sortId={this.state.sortId}
                                        onRequestSort={this.handleRequestSort}
                                    />
                                    <TableBody>
                                        {_recentOrders ? stableSort(_recentOrders, getSorting(FilterObj.sortOrder, FilterObj.sortColumn)).map((item, index) => {
                                            return (
                                                <TableRow>
                                                    <TableCell style={{ padding: '5px 5px', display: 'flex', alignItems: 'center', justifyContent: 'center', border: 'none' }}>
                                                        <Tooltip key={index} title={item && item.rowProperties && item.rowProperties.type}>
                                                            <span style={{ background: item && item.rowProperties && item.rowProperties.bgColor, border: '1px solid #888', borderRadius: '50%', height: '20px', width: '20px' }}>
                                                            </span>
                                                        </Tooltip>
                                                    </TableCell>
                                                    <TableCell style={{ padding: '5px 5px' }}>{item.name}</TableCell>
                                                    <TableCell style={{ padding: '5px 5px' }}>
                                                        <a href='' title="View Pick up by" style={{ fontWeight: 500, textDecoration: 'none ', fontSize: '1rem' }} onClick={(event) => this.handleStockCodeClick(event, item)}>{item.stock_code}</a>
                                                    </TableCell>
                                                    <TableCell style={{ padding: '5px 5px' }}>{item.binPosition}</TableCell>
                                                </TableRow>
                                            )
                                        }) :
                                            <TableRow>
                                                <TableCell style={{ borderBottom: 'none' }}></TableCell>
                                                <TableCell colSpan={4} style={{ borderBottom: 'none', textAlign: 'center' }}>{t("Unplugged.NoDataFound")}</TableCell>
                                            </TableRow>}
                                    </TableBody>
                                </Table>
                            </InfiniteScroll>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <List sx={{ display: 'flex', flexDirection: 'row' }}>
                                {legend.map((value) => {
                                    return (
                                        <ListItem disablePadding onClick={(e) => this.handleStatusClick(e, value.label)} sx={{ cursor: 'pointer', margin: '0 10px' }}>
                                            <ListItemIcon>
                                                <span style={{ background: value.color, height: '20px', width: '20px', border: '1px solid #888', borderRadius: '50%' }}>&nbsp;</span>
                                            </ListItemIcon>
                                            <ListItemText primary={value.label} />
                                        </ListItem>
                                    );
                                })}
                            </List>
                        </div>
                    </div>
                </div>
            </Box>
        )
    }
}

export default withStyles(styles)(withTranslation()(FastlaneProLayout));


// WEBPACK FOOTER //
// ./src/components/assign-prescriptions/fastlane-pro.js